import { useState } from 'react';
import EmbeddedFamilyCreation from './EmbeddedFamilyCreation';
import EmbeddedFamilyJoin from './EmbeddedFamilyJoin';

const OnboardingStep4Family = ({ onNext, onSkip, isLoading, setIsLoading }) => {
  const [mode, setMode] = useState(null); // 'create', 'join', or null

  const handleCreateFamily = (data) => {
    console.log('🔍 OnboardingStep4Family - handleCreateFamily called with:', data);
    onNext(data);
  };

  const handleJoinFamily = (data) => {
    console.log('🔍 OnboardingStep4Family - handleJoinFamily called with:', data);
    onNext(data);
  };

  const handleSkipFamily = () => {
    console.log('🔍 OnboardingStep4Family - handleSkipFamily called');
    onSkip();
  };

  return (
    <div className="onboarding-step family-step">
      <p>
        Families allow you to track reading progress together and encourage each other. 
        You can create a new family or join an existing one using an invite code.
      </p>

      {!mode ? (
        <div className="family-options">
          <div className="family-choice-grid">
            <div 
              className="family-choice-card"
              onClick={() => setMode('create')}
            >
              <div className="choice-icon">👨‍👩‍👧‍👦</div>
              <div className="choice-title">Create a Family</div>
              <div className="choice-description">
                Start a new family group and invite others to join
              </div>
            </div>

            <div 
              className="family-choice-card"
              onClick={() => setMode('join')}
            >
              <div className="choice-icon">🤝</div>
              <div className="choice-title">Join a Family</div>
              <div className="choice-description">
                Join an existing family using an invite code
              </div>
            </div>

            <div 
              className="family-choice-card solo"
              onClick={() => setMode('skip')}
            >
              <div className="choice-icon">👤</div>
              <div className="choice-title">Continue Solo</div>
              <div className="choice-description">
                Skip family setup for now (you can join or create one later)
              </div>
            </div>
          </div>
        </div>
      ) : mode === 'create' ? (
        <EmbeddedFamilyCreation
          onComplete={handleCreateFamily}
          onBack={() => setMode(null)}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      ) : mode === 'join' ? (
        <EmbeddedFamilyJoin
          onComplete={handleJoinFamily}
          onBack={() => setMode(null)}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      ) : (
        <div className="family-action">
          <div className="action-icon">👤</div>
          <h3>Continue Solo</h3>
          <p>
            No problem! You can always create or join a family later from your profile settings. 
            For now, you'll track your own reading progress.
          </p>
          <div className="step-actions">
            <button 
              type="button"
              className="btn-secondary"
              onClick={() => setMode(null)}
              disabled={isLoading}
            >
              Back
            </button>
            <button 
              className="btn-primary"
              onClick={handleSkipFamily}
              disabled={isLoading}
            >
              {isLoading ? 'Loading...' : 'Continue Solo'}
            </button>
          </div>
        </div>
      )}

      {!mode && (
        <div className="step-actions">
          <button 
            type="button"
            className="btn-secondary"
            onClick={onSkip}
            disabled={isLoading}
          >
            Skip for Now
          </button>
        </div>
      )}

      <style jsx>{`
        .family-step {
          text-align: center;
        }

        .family-choice-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
          margin: 32px 0;
        }

        .family-choice-card {
          padding: 24px 20px;
          border: 2px solid var(--color-border);
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s ease;
          background: var(--color-surface);
        }

        .family-choice-card:hover {
          border-color: var(--color-primary);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(43, 31, 23, 0.1);
        }

        .family-choice-card.solo {
          border-style: dashed;
          opacity: 0.8;
        }

        .choice-icon {
          font-size: 40px;
          margin-bottom: 16px;
        }

        .choice-title {
          font-size: 18px;
          font-weight: 600;
          color: var(--color-text);
          margin-bottom: 8px;
        }

        .choice-description {
          font-size: 14px;
          color: var(--color-text-secondary);
          line-height: 1.4;
        }

        .family-action {
          text-align: center;
          padding: 20px 0;
        }

        .action-icon {
          font-size: 48px;
          margin-bottom: 16px;
        }

        .family-action h3 {
          margin: 0 0 16px 0;
          color: var(--color-text);
          font-size: 20px;
        }

        .family-action p {
          margin-bottom: 24px;
        }

        @media (max-width: 768px) {
          .family-choice-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default OnboardingStep4Family;
